/**
 * Newsletter popup — global binder.
 * Listens for clicks on [data-rb-newsletter-open], opens the popup,
 * handles the signup form, displays the discount code.
 */
(function () {
  "use strict";
  var ENDPOINT = "https://rainbow-control-plane.vercel.app/api/newsletter-signup";

  function $(sel, root) { return (root || document).querySelector(sel); }
  // Testi tradotti (solo fuori dall'italiano): JSON in data-rb-nl-i18n sul popup, scritto dal Liquid. In italiano l'attributo non c'è.
  var I18N = null;
  function t(k, it) {
    if (I18N === null) { I18N = {}; try { var p = $("[data-rb-newsletter-popup]"); var raw = p && p.getAttribute("data-rb-nl-i18n"); if (raw) I18N = JSON.parse(raw) || {}; } catch (e) { I18N = {}; } }
    return I18N[k] || it;
  }
  function show(el) { if (el) el.style.display = ""; }
  function hide(el) { if (el) el.style.display = "none"; }

  function openPopup() {
    var pop = $("[data-rb-newsletter-popup]");
    if (!pop) return;
    pop.style.display = "";
    // Force reflow before adding class so transition fires
    void pop.offsetWidth;
    pop.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var input = $("[data-rb-nl-email]", pop);
    setTimeout(function () { input && input.focus(); }, 250);
  }
  function closePopup() {
    var pop = $("[data-rb-newsletter-popup]");
    if (!pop) return;
    pop.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () { pop.style.display = "none"; }, 250);
  }

  function setStep(name) {
    document.querySelectorAll("[data-rb-nl-step]").forEach(function (el) {
      el.style.display = el.getAttribute("data-rb-nl-step") === name ? "" : "none";
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var btn = form.querySelector("[data-rb-nl-submit]");
    var emailIn = form.querySelector("[data-rb-nl-email]");
    var consentIn = form.querySelector("[data-rb-nl-consent]");
    var errorEl = form.querySelector("[data-rb-nl-error]");
    if (errorEl) hide(errorEl);
    var email = (emailIn.value || "").trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      if (errorEl) { errorEl.textContent = t("invalid", "Email non valida"); show(errorEl); }
      emailIn.focus();
      return;
    }
    if (!consentIn.checked) {
      if (errorEl) { errorEl.textContent = t("consent", "Devi accettare le comunicazioni promozionali"); show(errorEl); }
      return;
    }
    btn.disabled = true;
    btn.textContent = t("sending", "Invio in corso...");
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, source: "cart_drawer_popup", accepts_marketing: true }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (r) {
        btn.disabled = false;
        btn.textContent = t("cta", "Ricevi il 10% di sconto");
        if (!r.ok) {
          if (errorEl) {
            errorEl.textContent = t("error", "") || r.body.message || r.body.error || "Si è verificato un errore. Riprova.";
            show(errorEl);
          }
          return;
        }
        // Persist locally so popup doesn't re-prompt
        try { localStorage.setItem("rb_newsletter_subscribed", "1"); } catch (e) {}
        if (r.body.already_subscribed) {
          setStep("already");
        } else {
          var codeEl = $("[data-rb-nl-code]");
          if (codeEl && r.body.code) codeEl.textContent = r.body.code;
          setStep("success");
        }
        try { if (window.rbTrack) window.rbTrack("newsletter_signup", { email_hash: btoa(email) }); } catch (e) {}
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = t("cta", "Ricevi il 10% di sconto");
        if (errorEl) { errorEl.textContent = t("network", "Errore di rete. Riprova tra un attimo."); show(errorEl); }
      });
  }

  function handleCopy(e) {
    var btn = e.currentTarget;
    var codeEl = $("[data-rb-nl-code]");
    if (!codeEl) return;
    var text = codeEl.textContent.trim();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(function () {
        btn.textContent = t("copied", "Copiato ✓");
        btn.classList.add("is-copied");
        setTimeout(function () { btn.textContent = t("copy", "Copia"); btn.classList.remove("is-copied"); }, 2000);
      });
    } else {
      var ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (e) {}
      document.body.removeChild(ta);
      btn.textContent = t("copied", "Copiato ✓");
      btn.classList.add("is-copied");
      setTimeout(function () { btn.textContent = t("copy", "Copia"); btn.classList.remove("is-copied"); }, 2000);
    }
  }

  function bind() {
    var pop = $("[data-rb-newsletter-popup]");
    if (!pop || pop.__rbInit) return;
    pop.__rbInit = true;
    var form = $("[data-rb-nl-form]", pop);
    if (form) form.addEventListener("submit", handleSubmit);
    pop.querySelectorAll("[data-rb-nl-close]").forEach(function (el) {
      el.addEventListener("click", closePopup);
    });
    var copy = $("[data-rb-nl-copy]", pop);
    if (copy) copy.addEventListener("click", handleCopy);
    // ESC to close
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && pop.classList.contains("is-open")) closePopup();
    });
  }

  // Open triggers (anywhere, dynamic or static)
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-rb-newsletter-open]");
    if (!trigger) return;
    e.preventDefault();
    bind();
    openPopup();
  });

  function init() { bind(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  if ("MutationObserver" in window) {
    new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
  }
})();
